export class BuyerOwnerResultDto {
    ownerId: number;
    communityId: number;
    ownerType: string;
    community: string;
    lastOrCompanyName: string;
    ownerName: string;
    mailingAddress: string;
}
